import { Theme } from "@emotion/react";
import { InputLabel, MenuItem, Select, SelectChangeEvent, SxProps, TextFieldProps as MuiTextFieldProps } from "@mui/material";
import FormControl from '@mui/material/FormControl';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import React from "react"

export interface SelectOptionProps {
    label: string;
    value: number | string;
}

interface SelectProps {
    id: string;
    value: string | string[];
    labelId?: string;
    label?: string;
    options: SelectOptionProps[];
    onChange: (value: string | string[]) => void;
    sx?: SxProps<Theme>;
    sxForm?: SxProps<Theme>;
    multiple?: boolean;
    disabled?: boolean;
    MenuProps?: any;
    required?: boolean;
    size?: MuiTextFieldProps['size']
}

const SelectComponent = (props: SelectProps) => {
    const handleChange = (event: SelectChangeEvent<typeof props.value>) => {
        const value = event.target.value;

        props.onChange(
            props.multiple
                ? (typeof value === "string" ? value.split(",") : value)
                : value
        );
    };

    return <FormControl sx={props.sxForm}>
        <InputLabel id="demo-simple-select-helper-label">{props.label}</InputLabel>
        <Select
            labelId={props.labelId}
            id={props.id}
            value={props.value}
            label={props.label}
            onChange={handleChange}
            renderValue={(selected) => {
                if (Array.isArray(selected)) {
                    const labels = props.options
                        .filter(opt => selected.includes(String(opt.value)))
                        .map(opt => opt.label);
            
                    return labels.join(", ");
                }
            
                const option = props.options.find(opt => String(opt.value) === selected);
                return option?.label || "";
            }}
            sx={props.sx}
            multiple={props.multiple}
            disabled={props.disabled}
            MenuProps={props.MenuProps}
            required={props.required}
            size={props.size}
        >
            {props.options.map((element, index) => {
                const isSelected = Array.isArray(props.value)
                    ? props.value.includes(String(element.value))
                    : props.value === String(element.value);
                const SelectionIcon = isSelected ? CheckBoxIcon : CheckBoxOutlineBlankIcon;

                return <MenuItem
                    key={`${props.id}-${index}`}
                    value={element.value}
                >
                    {props.multiple && <>
                        <SelectionIcon
                            fontSize="small"
                            style={{ marginRight: 8, padding: 9, boxSizing: 'content-box' }}
                        />
                    </>}
                    {element.label}
                </MenuItem>
            })}
        </Select>
    </FormControl>
}

export default SelectComponent;